import { THEME } from 'styles/themes';

export const colors = THEME.Private.colors ?? {};

export const typography = THEME.Private.typography ?? {};

export const options = THEME.Private.options ?? {};
